import { createFileRoute } from "@tanstack/react-router";
import { TicketReport } from "@/features/tickets/TicketReport";

export const Route = createFileRoute("/_authenticated/reports/cross-department-tickets")({
  component: () => (
    <TicketReport
      id="R-47"
      title="Cross-Department Tickets"
      description="Tickets raised by users in a department different from the asset's owning department."
      baseFilters={{ crossDepartmentOnly: true }}
      enabledFilters={["branch", "department", "status", "priority", "dateRange"]}
      filename="cross-department-tickets"
    />
  ),
});
